/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Database } from './Database';
import {
    DatabaseFromJSON,
    DatabaseFromJSONTyped,
    DatabaseToJSON,
} from './Database';
import type { Subscription } from './Subscription';
import {
    SubscriptionFromJSON,
    SubscriptionFromJSONTyped,
    SubscriptionToJSON,
} from './Subscription';
import type { TenantCustomerSubscription } from './TenantCustomerSubscription';
import {
    TenantCustomerSubscriptionFromJSON,
    TenantCustomerSubscriptionFromJSONTyped,
    TenantCustomerSubscriptionToJSON,
} from './TenantCustomerSubscription';

/**
 * 
 * @export
 * @interface MyDbCustomerSubscription
 */
export interface MyDbCustomerSubscription extends TenantCustomerSubscription {
    /**
     * 
     * @type {number}
     * @memberof MyDbCustomerSubscription
     */
    numDatabasesUsed?: number;
    /**
     * 
     * @type {number}
     * @memberof MyDbCustomerSubscription
     */
    storageCapacityUsedInMb?: number;
    /**
     * 
     * @type {boolean}
     * @memberof MyDbCustomerSubscription
     */
    databasesLocked?: boolean;
    /**
     * 
     * @type {Array<Database>}
     * @memberof MyDbCustomerSubscription
     */
    databases?: Array<Database>;
    /**
     * 
     * @type {number}
     * @memberof MyDbCustomerSubscription
     */
    numDatabasesAvailable?: number;
    /**
     * 
     * @type {number}
     * @memberof MyDbCustomerSubscription
     */
    storageCapacityInMb?: number;
    /**
     * Maximale Anzahl Datensätze pro Datenbank (null/0 = unbegrenzt)
     * @type {number}
     * @memberof MyDbCustomerSubscription
     */
    maxEntriesPerDatabase?: number;
}

/**
 * Check if a given object implements the MyDbCustomerSubscription interface.
 */
export function instanceOfMyDbCustomerSubscription(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MyDbCustomerSubscriptionFromJSON(json: any): MyDbCustomerSubscription {
    return MyDbCustomerSubscriptionFromJSONTyped(json, false);
}

export function MyDbCustomerSubscriptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): MyDbCustomerSubscription {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...TenantCustomerSubscriptionFromJSONTyped(json, ignoreDiscriminator),
        'numDatabasesUsed': !exists(json, 'numDatabasesUsed') ? undefined : json['numDatabasesUsed'],
        'storageCapacityUsedInMb': !exists(json, 'storageCapacityUsedInMb') ? undefined : json['storageCapacityUsedInMb'],
        'databasesLocked': !exists(json, 'databasesLocked') ? undefined : json['databasesLocked'],
        'databases': !exists(json, 'databases') ? undefined : ((json['databases'] as Array<any>).map(DatabaseFromJSON)),
        'numDatabasesAvailable': !exists(json, 'numDatabasesAvailable') ? undefined : json['numDatabasesAvailable'],
        'storageCapacityInMb': !exists(json, 'storageCapacityInMb') ? undefined : json['storageCapacityInMb'],
        'maxEntriesPerDatabase': !exists(json, 'maxEntriesPerDatabase') ? undefined : json['maxEntriesPerDatabase'],
    };
}

export function MyDbCustomerSubscriptionToJSON(value?: MyDbCustomerSubscription | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...TenantCustomerSubscriptionToJSON(value),
        'numDatabasesUsed': value.numDatabasesUsed,
        'storageCapacityUsedInMb': value.storageCapacityUsedInMb,
        'databasesLocked': value.databasesLocked,
        'databases': value.databases === undefined ? undefined : ((value.databases as Array<any>).map(DatabaseToJSON)),
        'numDatabasesAvailable': value.numDatabasesAvailable,
        'storageCapacityInMb': value.storageCapacityInMb,
        'maxEntriesPerDatabase': value.maxEntriesPerDatabase,
    };
}

